// flowbite-datepicker を npm (node_modules) から取り込んで esbuild でバンドルする「真に npm 管理された」
// エントリ (issue #2122)。従来は手動コミットの UMD 静的ファイル public/js/flowbite-datepicker.js を
// 生の <script> で配信しており、package.json のバージョンと配信コードが乖離していた。
//
// ⚠️ このバンドルは必ず `--format=iife` でビルドすること (issue #2139 の再発防止)。
// application-esbuild.js と本バンドルはどちらもクラシック <script> で読み込まれるため、
// `--format=esm` で出力するとトップレベル宣言 (addDays / getWeek 等の date 関数名) がグローバルに
// 漏れ、後から読まれた本バンドルが react-day-picker の date-fns 関数を上書きして
// 空き状況カレンダーの曜日1列ずれ・白画面を引き起こす (issue #2139 / 是正 PR #2140)。
// 回帰ガード: client/spec/esbuild-bundle-isolation.spec.ts
//
// 現行 UMD ビルドの自動初期化ロジックのうち、本リポジトリで実際に使われている
// [inline-datepicker] 属性の初期化のみを移植する（未使用の [datepicker] / [date-rangepicker] と
// datepicker-* オプション属性は移植しない）。
//
// 使用箇所: app/views/plans/components/crawler.haml / crawler+mobile.haml の inline-datepicker 要素。
// 初期化後は app/javascript/controllers/date_range_picker_controller.js がクラスを書き換えて描画する。
//
// ⚠️ 初期化タイミング (issue #2122 の実機不具合対応):
// 本バンドルは fronts.haml の <body> 末尾のクラシック <script> で読み込まれ、対象の
// [inline-datepicker] 要素はこの時点で既に解析済みである。一方 importmap(Stimulus) は head の
// deferred module として読み込まれ、DOMContentLoaded より前に実行され controller を connect する。
// そのため DOMContentLoaded を待って初期化すると、date_range_picker_controller.connect() が
// datepicker 未描画（.datepicker-cell が 0 件）の DOM を掴んでしまい、月要素の走査結果から
// [data-month] を null 参照して落ちる。Rails 8 / importmap 化で module 実行タイミングが早まり顕在化した。
// → 対象要素は本 <script> より前にあり解析済みのため、DOMContentLoaded を待たず即時初期化して
//   deferred module の connect より確実に先行させる。
//   （<body> 末尾での実行時 readyState は 'loading' のため readyState ガードでは遅延してしまう点に注意。
//    idempotent ガードを入れ、万一 head 等で読まれ対象未解析だった場合のフォールバックとして
//    DOMContentLoaded でも走らせる。二重初期化はしない。）
import { Datepicker } from 'flowbite-datepicker'

function initDatepickers() {
  document.querySelectorAll<HTMLElement>('[inline-datepicker]').forEach((el) => {
    if (el.dataset.datepickerInitialized) return
    el.dataset.datepickerInitialized = 'true'
    new Datepicker(el, {})
  })
}

// 末尾 script のため通常はこの即時実行で初期化される（deferred module の connect より前）。
initDatepickers()
// フォールバック: 対象要素が未解析（例: head 読み込み）の場合に備える。
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initDatepickers)
}
